import { render, staticRenderFns } from "./UniformsList.vue?vue&type=template&id=5989e84b&scoped=true"
import script from "./UniformsList.vue?vue&type=script&lang=js"
export * from "./UniformsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989e84b",
  null
  
)

export default component.exports